<template>
    <b-list-group>
        <b-list-group-item v-if="history.length < 1"> {{ $t('noCreditsHistory') }}  </b-list-group-item>
        <b-list-group-item v-for="item in history" :key="item.uuid"> {{ item.comment }}  <b-badge :variant="item.amount > 0 ? 'success' : 'danger'" class="float-right">{{ item.amount }}</b-badge></b-list-group-item>
    </b-list-group>
</template>

<script>
export default {
    name: "CreditsHistory",
    data: function() {
        return {
            history: []
        }
    },

    mounted() {
        this.$http.get("/v1/user/credits/history").then(resp => {
            this.history = resp.data
        }).catch(error => {
            if (error.response.status == 500) {
              this.$serverErrorModal(error)
              return
            }

            this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
